module.exports = __webpack_public_path__ + "img/armourfuse.db3fb1d6.png";